import { Injectable, inject } from '@angular/core';

import { DateProviderService } from '@frontend/sports/common/core/utils/date';
import { CookieService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class CookieProvider {
    private cookies = inject(CookieService);

    getCookie(name: string): string {
        return this.cookies.get(name);
    }

    setCookie(name: string, value: string, options?: { expires?: number }): void {
        const expire = this.cookieExpirationDate(options?.expires);

        this.cookies.put(name, value, { expires: expire });
    }

    deleteCookie(name: string): void {
        this.cookies.remove(name);
    }

    private cookieExpirationDate(days?: number): Date | undefined {
        if (days == null) {
            return;
        }

        const result = DateProviderService.getDate();
        result.setDate(result.getDate() + days);

        return result;
    }
}
